import { useQuery } from '@tanstack/react-query';

import { fetchOCClaimStatus } from '../../data-provider/select-options';

export const useGetOCClaimStatus = () => {
  return useQuery({
    queryFn: () => fetchOCClaimStatus(),
    queryKey: ['claims-over-charge-status'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
